import { EventBus } from "../events/EventBus";
import { EventTypes } from "../events/EventTypes";
import { Config } from "../config/Config";
import { Choice, Color } from "../../../src/wix-api/typedefs/IWixItemsInCollection";

export class MenuItemImage {
  public thumbSize: number = Config.THUMBSIZE;
  public videoUrl: string | undefined;
  private eventBus: EventBus;
  public image!: HTMLImageElement;
  public id: string;
  private src: string;
  private color: string | undefined;
  private colorInfo: Choice | undefined;

  constructor(eventbus: EventBus, id: string, src: string, color?: string, colorInfo?: Choice) {
    this.eventBus = eventbus;
    this.id = id;
    this.src = src;
    this.color = color;
    this.colorInfo = colorInfo;
  }
  doClick() {
    this.eventBus.dispatchEvent({
      type: EventTypes.MENU_ITEM_CLICKED,
      eventData: {
        id: this.id,
        videoURL: this.videoUrl,
        colorInfo: this.colorInfo
      },
    });
  }
  render(): HTMLImageElement {
    this.image = document.createElement('img') as HTMLImageElement;
    this.image.classList.add('flex-item');
    let url = this.src;
    if(!this.color){
      url = `${url}/v1/fill/w_${this.thumbSize},h_${this.thumbSize},q_85,usm_0.66_1.00_0.01/${url.substring(url.lastIndexOf('/') + 1)}`;
    }
    if(this.colorInfo?.mainMedia && this.colorInfo.mainMedia.indexOf('rainbow') > -1 ) {
      this.color = '#EFECE2';
      this.image.alt = 'Order form to place your personal order';
    } else {
      this.image.alt = this.colorInfo?.description || '';
    }

    this.image.title = this.image.alt;
    this.image.src = url;
    this.image.id = this.id;
    this.image.onclick = () => {
      this.doClick();
    };

    if (this.color) {
      this.image.style.borderColor = this.color;
      this.image.style.backgroundColor = this.color;
    }
    return this.image;
  }
  remove() {
    if (this.image?.parentElement) {
      this.image.parentElement.removeChild(this.image);
    }
  }
}
